import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { Delete, CloudDownload } from '@material-ui/icons';
import { AiOutlineFileProtect, AiOutlineTable } from 'react-icons/ai';
import { IoIosInformationCircle } from 'react-icons/io'

import moment from 'moment';
import { jsPDF } from 'jspdf';
import { useReactToPrint } from 'react-to-print';
import ReactDOM from "react-dom";
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';

import Loading from '../../../Components/Loading';
import SemDados from '../../../Components/SemDados';
import TableCustom from '../../../Components/Table';
import ModalExclusao from '../../../Components/ModalExclusao';
import LoadingButton from '../../../Components/LoadingButton';
import DrawerEspelhoPerdcomp from './DrawerEspelhoPerdcomp';
import DadosEspelho from './DrawerEspelhoPerdcomp/DadosEspelho';
import ModalConfirmacao from '../../../Components/ModalConfirmacao';

import { buscarTodosEspelhos, exportarRelatorio, listarRestituicao } from '../../../Store/Actions/API/restituicaoActions';
import { excluirResultado } from '../../../Store/Actions/API/resultadosActions';
import { setParamsFilterRestituicao } from '../../../Store/Actions/Reducer/seguradoActions';
import { formataNit, formatarReais } from '../../../Utils/utils';
import { useStyles } from './styles';

export default function Restituicao({ cpf, nome }) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const paramsFiltroRestituicao = useSelector((state) => state.segurado.paramsFiltroRestituicao, shallowEqual);
    const ultimoUpdateNit = useSelector((state) => state.menu.ultimoUpdateNit, shallowEqual);

    const [isLoading, setLoading] = useState(false);
    const [isLoadingExportar, setLoadingExportar] = useState(false);
    const [isLoadingBaixarTodas, setLoadingBaixarTodas] = useState(false);
    const [isLoadingExcluir, setLoadingExcluir] = useState(false);

    const [resultados, setResultados] = useState([]);
    const [quantidadeBanco, setQuantidadeBanco] = useState(0);
    const [creditoTotal, setCreditoTotal] = useState(null);
    const [creditoTotalSelic, setCreditoTotalSelic] = useState(null);

    const [resultadoSelecionado, setResultadoSelecionado] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [openModalExclusao, setOpenModalExclusao] = useState(false);

    const [bloquearExclusao, setBloquearExclusao] = useState(false);

    const [openModalAnexo, setOpenModalAnexo] = useState(false);

    useEffect(() => {
        lidarListagemRestituicao();
    }, [paramsFiltroRestituicao, ultimoUpdateNit]); // eslint-disable-line

    const lidarListagemRestituicao = async () => {
        const filtros = {
            ...paramsFiltroRestituicao,
            cpf
        };

        setLoading(true);

        const response = await listarRestituicao(filtros);

        if (response !== null) {
            setQuantidadeBanco(response.quantidade ?? 0);
            setResultados(response.resultados ?? []);
            setCreditoTotal(response.creditoTotal ?? 0);
            setCreditoTotalSelic(response.creditoTotalSelic ?? 0);
            setBloquearExclusao(response.bloquearExclusao ?? false);
        }

        setLoading(false);
    }

    const lidarExportarRelatorio = async () => {
        setLoadingExportar(true);
        await exportarRelatorio(cpf);
        setLoadingExportar(false);
    }

    const lidarBaixarTodasCompetencias = async () => {
        setLoadingBaixarTodas(true);

        const zip = require('jszip')();

        let espelhos = await buscarTodosEspelhos({ cpf });

        if (!espelhos) {
            setLoadingBaixarTodas(true);
            return;
        }

        let competenciasFinalizadas = []
        let contador = 0;
        let index = 0;

        const verificarCompetencias = async () => {
            let competenciasNaoFinalizadas = (espelhos ?? []).filter((result) => !competenciasFinalizadas.includes(result.competencia));

            for (const resultado of competenciasNaoFinalizadas) {
                index++;
                let resultadoSelecionadoLocal = { idResultado: resultado.id, competencia: resultado.competencia }

                let dadosPerdcomp = resultado;

                const recebeDados = async (dados, dadosEspelho) => { // eslint-disable-line
                    const document = dados.contentDocument;

                    if (document) {
                        const html = document.getElementsByTagName("html")[0];
                        html.style.width = '1200px'
                        let jspedef = new jsPDF('p', 'pt', 'a4')
                        jspedef.setFontSize(12)
                        let htmlWorker = jspedef.html(html, { html2canvas: { width: 1200, scale: 0.5 } })
                        let tmp = htmlWorker.outputPdf("blob")
                        zip.file(`espelho-${cpf}-${resultadoSelecionadoLocal.competencia}.pdf`.replace('/', '-'), tmp, { type: 'application/pdf' })

                        let verificaExistencia = competenciasFinalizadas.filter((x) => x === resultadoSelecionadoLocal.competencia)
                        if (verificaExistencia.length === 0) {
                            competenciasFinalizadas.push(resultadoSelecionadoLocal.competencia);
                            contador++;
                        }
                    }
                }

                let exemplo = <ComponentePDF modoImprimir={true}
                    key={index}
                    cpf={cpf}
                    index={index}
                    nome={nome}
                    resultadoSelecionado={resultadoSelecionadoLocal}
                    dadosEspelho={dadosPerdcomp}
                    enviaDados={async (dados, dadosEspl) => await recebeDados(dados, dadosEspl)} />

                var div = document.createElement(`div${index}`);

                ReactDOM.render(
                    exemplo,
                    div
                );
            }
        }

        verificarCompetencias();

        let contadorFlag = 0;

        const checkFlag = async () => {
            if (contador !== espelhos.length) {
                contadorFlag++;
                if (contadorFlag === 5) {
                    contadorFlag = 0;
                    await verificarCompetencias()
                    checkFlag();
                } else {
                    window.setTimeout(checkFlag, 200);
                }
            } else {
                setLoading(true);
                setTimeout(async () => {
                    let content = await zip.generateAsync({ type: "blob" })
                    saveAs(content, `espelhos-${nome}.zip`);
                    toast.success("Relatório gerado com sucesso.");
                    setLoadingBaixarTodas(false);
                    setLoading(false);
                }, 1000)
            }
        }

        await checkFlag();
    }

    const onChangePagination = (pag) => {
        dispatch(setParamsFilterRestituicao(pag));
    }

    const clicaExcluirResultado = (row) => {
        setResultadoSelecionado({ competencia: row.competencia });
        setOpenModalExclusao(true);
    }

    const cancelaExcluirResultado = () => {
        setResultadoSelecionado(null);
        setOpenModalExclusao(false);
    }

    const confirmaExcluirResultado = async () => {
        if (resultadoSelecionado) {
            setLoadingExcluir(true);
            await excluirResultado(cpf, resultadoSelecionado.competencia);
            setLoadingExcluir(false);
            setResultadoSelecionado(null);
            setOpenModalExclusao(false);
            lidarListagemRestituicao();
        }
    }

    const clicaVisualizarResultado = (row) => {
        setResultadoSelecionado({ competencia: row.competencia });
        setOpenDrawer(true);
    }

    const fechaVisualizarResultado = () => {
        setResultadoSelecionado(null);
        setOpenDrawer(false);
    }

    const toolTipAnexoMEI = () => {
        return (
            <Tooltip title="Espelho PER/DCOMP não disponível" arrow>
                        <IconButton size='small' onClick={ () => {setOpenModalAnexo(true)}}>
                            <IoIosInformationCircle size={23} color='#FFB626' />
                        </IconButton>
            </Tooltip>
        );
    }

    const fecharModalAnexoMEI = () => {
        setOpenModalAnexo(false)
    }
    
    const textoModalAnexoMEI = () => {
        return (
            <div>
                <p>
                    O pedido de restituição via PER/DCOMP não está disponível para competências com contribuição recolhida sob o código MEI. 
                </p>
                <p>
                    Para realizá-lo, informe os dados no Pedido de Restituição ou de Ressarcimento – Anexo I, Pagamento Indevido ou a Maior – Contribuição Previdenciária.
                </p>
            </div>
        );
    }

    const columns = [
        {
            title: "Competência",
            dataIndex: "competencia",
            key: "competencia",
            align: "center",
            width: 30,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value}</p>,
        },
        {
            title: "NIT",
            dataIndex: "nit",
            key: "nit",
            align: "center",
            render: (value, row) => <p style={{ fontSize: 13 }}>{(value !== '-') ? formataNit(value) : '-'}</p>,
        },
        {
            title: "Categoria do Segurado",
            dataIndex: "tipoFiliadoVinculo",
            key: "tipoFiliadoVinculo",
            align: "center",
            render: (value, row) => <p style={{ fontSize: 13 }}>{value}</p>,
        },
        {
            title: "Justificativa do Pedido",
            dataIndex: "justificativaPedido",
            key: "justificativaPedido",
            align: "center",
            render: (value, row) => <p style={{ fontSize: 13 }}>{value}</p>,
        },
        {
            title: "Valor do Pedido de Restituição",
            dataIndex: "valorCredito",
            key: "valorCredito",
            align: "center",
            render: (value, row) => <p style={{ fontSize: 13 }}>{(value !== '-') ? formatarReais(value) : '-'}</p>,
        },
        {
            title: "Data Selic",
            dataIndex: "dataSelic",
            key: "dataSelic",
            align: "center",
            render: (value, row) => <p style={{ fontSize: 13 }}>{value !== '-' ? moment(value).format('MM/YYYY') : '-'}</p>,
        },
        {
            title: "Percentual Selic",
            dataIndex: "percentualSelic",
            key: "percentualSelic",
            align: "center",
            render: (value, row) => <p style={{ fontSize: 13 }}>{(value !== '-') ? `${value}%`.replace('.', ',') : '-'}</p>,
        },
        {
            title: "Crédito Atualizado Selic",
            dataIndex: "creditoAtualizado",
            key: "creditoAtualizado",
            align: "center",
            render: (value, row) => <p style={{ fontSize: 13 }}>{(value !== '-') ? formatarReais(value) : '-'}</p>,
        },

        {
            title: "Ações",
            dataIndex: "acoes",
            key: "acoes",
            align: "center",
            render: (value, row) => <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ paddingRight: 3 }}>
                    {
                        row.possuiContribuicaoMEI ? toolTipAnexoMEI() : 
                            <Tooltip title="Visualizar espelho do PER/DCOMP" arrow>
                                <IconButton size='small' onClick={() => clicaVisualizarResultado(row)}>
                                    <AiOutlineFileProtect size={23} /> 
                                </IconButton>
                            </Tooltip>
                    }
                </div>
                <div style={{ paddingLeft: 3 }}>
                    <Tooltip title="Excluir resultado" arrow>
                        <IconButton disabled={bloquearExclusao} size='small' onClick={() => clicaExcluirResultado(row)}>
                            <Delete />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>,
        }
    ];

    const propsTable = {
        columns,
        data: resultados,
        optionsPagination: {
            count: quantidadeBanco,
            pagination: { ...paramsFiltroRestituicao },
            onChangePagination,
        },
        optionsToolbar: {
            info: (
                <div className={classes.rowHeader}>
                    <div className={classes.colTitle}>
                        <div style={{ paddingLeft: 5 }}>
                            <Typography className={classes.headerTitle}>Apuração do crédito</Typography>
                        </div>
                        <div style={{ marginTop: 5, marginBottom: 2 }}>
                            <Typography className={classes.subheader}>
                                <span>
                                    <b>Total do crédito apurado:</b>{" "}
                                    {!Number.isNaN(creditoTotal) ? formatarReais(creditoTotal) : '-'}
                                </span>
                            </Typography>
                        </div>
                        <div style={{ marginBottom: 5 }}>
                            <Typography className={classes.subheader}>
                                <span>
                                    <b>Total do crédito atualizado pela SELIC:</b>{" "}
                                    {!Number.isNaN(creditoTotalSelic) ? formatarReais(creditoTotalSelic) : '-'}
                                </span>
                            </Typography>
                        </div>
                    </div>
                    <div className={classes.colButton}>
                        <div style={{ marginRight: 15 }}>
                            <LoadingButton
                                id="button_exportar_planilha"
                                variant="contained"
                                color="inherit"
                                startIcon={<AiOutlineTable color={isLoadingExportar ? 'gray' : '#000000'} />}
                                onClick={lidarExportarRelatorio}
                                size={'small'}
                                loading={isLoadingExportar}
                                style={{ color: isLoadingExportar ? 'gray' : '#000000' }}
                            >
                                Exportar planilha
                            </LoadingButton>
                        </div>
                        <div>
                            <LoadingButton
                                id="button_baixar_todas_competencias"
                                variant="contained"
                                color="primary"
                                startIcon={<CloudDownload color={isLoadingBaixarTodas ? 'gray' : '#000000'} />}
                                onClick={lidarBaixarTodasCompetencias}
                                size={'small'}
                                loading={isLoadingBaixarTodas}
                                style={{ color: isLoadingBaixarTodas ? 'gray' : '#000000' }}
                            >
                                Baixar todas as competências
                            </LoadingButton>
                        </div>
                    </div>
                </div>
            ),
        },
        heightBody: "calc(100vh - 465px)",
        minHeightBody: "calc(100vh - 465px)"
    };

    
    return (
        <>
            <ModalConfirmacao
                open={openModalAnexo}
                onConfirma={() => { 
                    window.open('https://www.gov.br/receitafederal/pt-br/centrais-de-conteudo/formularios/impostos/restituicao/restituicao', '_blank', 'noreferrer');
                    fecharModalAnexoMEI()
                }}
                confirmarTextComponent={<b>PREENCHER ANEXO I</b>}
                onCancela={fecharModalAnexoMEI}
                textoComponent={textoModalAnexoMEI()}
            />
            {(openDrawer && resultadoSelecionado !== null) && <DrawerEspelhoPerdcomp
                open={openDrawer}
                fechar={fechaVisualizarResultado}
                resultadoSelecionado={resultadoSelecionado}
                cpf={cpf}
                nome={nome}
            />}
            {(openModalExclusao && resultadoSelecionado !== null) && <ModalExclusao
                open={openModalExclusao}
                titulo={'Excluir Resultado'}
                onConfirma={confirmaExcluirResultado}
                loading={isLoadingExcluir}
                onCancela={cancelaExcluirResultado}
                textoComponent={<span>
                    Tem certeza que deseja apagar o resultado da competência
                    <b>{" " + resultadoSelecionado.competencia}</b>?{" "}
                    Todos os registros serão apagados e não será possível resgatá-los
                    novamente.
                </span>}
            />}
            {(!isLoading && resultados.length === 0) && (
                <SemDados text="Nenhum registro encontrado" />
            )}
            {(!isLoading && resultados.length > 0) && (
                <TableCustom {...propsTable} />
            )}
            {isLoading ? <Loading text={"Carregando dados de restituição..."} /> : null}
            {isLoadingBaixarTodas ? <Loading zIndex2={true} text={"Gerando os PDFs, por favor aguarde..."} /> : null}
        </>
    )
}

const ComponentePDF = ({ dadosEspelho, nome, cpf, resultadoSelecionado, enviaDados = () => { } }) => {
    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        print: async (printIframe) => {
            enviaDados(printIframe, dadosEspelho)
        },
        suppressErrors: true
    });

    useEffect(() => {
        setTimeout(() => {
            handlePrint()
        }, 300)
    }, []) // eslint-disable-line

    return (
        <div key={`${Math.random()}`}>
            <div style={{ display: 'none' }}>
                <div ref={componentRef} key={`${Math.random()}`}>
                    <DadosEspelho
                        modoImprimir={true}
                        cpf={cpf}
                        nome={nome}
                        resultadoSelecionado={resultadoSelecionado}
                        dadosEspelho={dadosEspelho}
                        modoImprimirTodos={true} />
                </div>
            </div>
        </div>
    );
};
